import React, { useContext } from 'react'
import styled from 'styled-components'
import { Button } from 'pcln-design-system'
import { themeGet } from '@styled-system/theme-get'
import { SetiRedesignContext } from '../providers/RedesignProvider'

const StyledButton = styled(Button)<{ isHotelsCornerShadClrVariant: boolean }>`
  height: 56px;
  border-radius: ${props =>
    props.isHotelsCornerShadClrVariant ? themeGet('borderRadii.lg') : ''};
`

type SearchFormButtonProps = {
  buttonText: string
  handleClick?: () => void
  [key: string]: unknown
}
export default function SearchFormButton({
  buttonText,
  handleClick = () => {
    // empty default function
  },
  ...buttonProps
}: SearchFormButtonProps) {
  const { isHotelsCornerShadClrVariant } = useContext(SetiRedesignContext)
  return (
    <StyledButton
      width={1}
      px={1}
      py={0}
      size="large"
      onClick={handleClick}
      type="submit"
      {...buttonProps}
      isHotelsCornerShadClrVariant={isHotelsCornerShadClrVariant}
    >
      {buttonText}
    </StyledButton>
  )
}
